"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var theme_1 = require("./theme");
var BaseModal_1 = require("./BaseModal");
var Text_1 = require("./Text");
var modalSizes = {
    small: "512px",
    medium: "608px",
};
var getWidthStyles = function (width) {
    if (!width)
        return undefined;
    if (width in modalSizes) {
        return {
            width: "100%",
            maxWidth: modalSizes[width],
        };
    }
    else {
        return {
            width: "100%",
            maxWidth: width,
        };
    }
};
/**
 * Main Modal component.
 * @param {Function} hideModal - Required. Function that will run on modal exit
 * @param {boolean} isOpen - Required. Describes if the modal should be shown or not
 * @param {string=} title - Title of the modal
 * @param {string=} width - Can be small, medium, or a custom pixel value
 * @param {ReactComponent=} actions - React component for the button action row
 * @param {boolean=} showIcon - Controls visibility of the close icon
 * @param {string=} maxHeight - Overrides the max scroll container height
 * @param {string=} margin - Overrides the default margin style
 * @param {Object=} style - Custom style object used in react-modal
 * @param {Object=} style.content - Custom content styles
 * @param {Object=} style.overlay - Custom overlay styles
 * @param {boolean=} shouldCloseOnOverlayClick - Controls whether the overlay should close the modal
 * @param {boolean=} shouldCloseOnEsc - Controls whether the esc key should close the modal
 */
var Modal = function (_a) {
    var isOpen = _a.isOpen, hideModal = _a.hideModal, title = _a.title, width = _a.width, actions = _a.actions, children = _a.children, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.showIcon, showIcon = _c === void 0 ? true : _c, shouldCloseOnOverlayClick = _a.shouldCloseOnOverlayClick, shouldCloseOnEsc = _a.shouldCloseOnEsc, _d = _a.margin, margin = _d === void 0 ? "16px 24px" : _d, _e = _a.maxHeight, maxHeight = _e === void 0 ? "calc(85vh - 108px)" : _e;
    var widthStyles = getWidthStyles(width);
    return (react_1.default.createElement(BaseModal_1.BaseModal, { isOpen: isOpen, hideModal: hideModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEsc: shouldCloseOnEsc, style: __assign(__assign({}, style), { overlay: __assign({ display: "flex", justifyContent: "center", boxSizing: "border-box", backgroundColor: theme_1.theme.colors.black4, zIndex: 2 }, style.overlay), content: __assign(__assign({ position: "relative", borderRadius: "8px", border: 0, inset: 0, 
                // TODO: Custom colors for shadows
                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)", padding: 0, margin: "auto 16px", boxSizing: "border-box" }, widthStyles), style.content) }) },
        react_1.default.createElement(ContentWrapper, { margin: margin },
            (title || showIcon) && (react_1.default.createElement(TitleWrapper, null,
                title && react_1.default.createElement(Text_1.Text, { variant: "headlineSmall" }, title),
                showIcon && (react_1.default.createElement(IconWrapper, { onClick: hideModal },
                    react_1.default.createElement(react_feather_1.X, { size: 18, stroke: theme_1.theme.colors.gray600 }))))),
            react_1.default.createElement(ScrollDiv, { maxHeight: maxHeight }, children)),
        actions && react_1.default.createElement(ActionWrapper, null, actions)));
};
exports.Modal = Modal;
var ContentWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var margin = _a.margin;
    return margin;
});
var ScrollDiv = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-height: ", ";\n  overflow-y: auto;\n  padding: 4px;\n  margin: -4px;\n"], ["\n  max-height: ", ";\n  overflow-y: auto;\n  padding: 4px;\n  margin: -4px;\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight;
});
var TitleWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n"])));
var IconWrapper = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  margin-left: auto;\n"], ["\n  cursor: pointer;\n  margin-left: auto;\n"])));
var ActionWrapper = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", ";\n  padding: 16px 24px;\n  display: flex;\n  justify-content: flex-end;\n  grid-column-gap: 16px;\n  margin-top: 40px;\n"], ["\n  background: ", ";\n  padding: 16px 24px;\n  display: flex;\n  justify-content: flex-end;\n  grid-column-gap: 16px;\n  margin-top: 40px;\n"])), theme_1.theme.colors.gray200);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
